// Handles the logic related to the PWA installation, prompt and state
// NOTE: A2hs is only relevant in the PWA web app running in a browser (usually mobile) supports PWA

import Vue from 'vue';
import A2hsDialog from './components/A2hsDialog';
import popupLock from './popupLock';
import { i18n } from '@/i18n';

export default {
  installPromptEvent: null,
  isIOS: false,
  isAndroid: false,
  hasShown: false,
  lastShowedAt: 0,
  hasInstalled: false,

  // init() should always be called before calling any other methods. Should be initialzed only once.
  init(isIOS, isAndroid) {
    let that = this;
    this.isIOS = isIOS;
    this.isAndroid = isAndroid;
    // handle a2hs callback
    if (this.isAndroid) {
      window.addEventListener('beforeinstallprompt', (event) => {
        // Prevent Chrome <= 67 from automatically showing the prompt
        event.preventDefault();
        // Stash the event so it can be triggered later.
        that.installPromptEvent = event;
      });
    }
    this.lastShowedAt = parseInt(window.localStorage.getItem('a2hs_last_showed_at') || 0);
    this.hasInstalled = !!parseInt(window.localStorage.getItem('a2hs_has_installed') || 0);
  },

  // show() renders the add to home screen prompt when appropriate
  show({ force = false, message = null } = {}) {
    if (!!window.cordova) { return; }
    let now = Math.floor(Date.now() / 1000);
    let notAvailable = false;
    if (!this.isIOS && !this.isAndroid) { notAvailable = true; } // only show for ios and android
    if (this.isAndroid) {
      if (!this.installPromptEvent) { notAvailable = true; } // only show if the android devise supports it and the app hasn't been installed. comment out to debug
    }
    if (!force) {
      if (notAvailable) { return; }
      if (this.lastShowedAt + 90 * 86400 > now) { return; } // only show if has bene show in last 90 days. comment out to debug
      if (this.hasShown) { return; } // only show if has been shown on this visit. comment out to debug
      if (popupLock.isLocked()) { return } // only show if no other popup has been shown recently
    }
    popupLock.set();
    const A2hsDialogC = Vue.extend({ ...A2hsDialog, i18n });
    let instance = new A2hsDialogC({
      propsData: {
        message: message,
        notAvailable: notAvailable,
      }
    });
    instance.$mount();
    document.body.appendChild(instance.$el);
    this.hasShown = true;
    window.localStorage.setItem('a2hs_last_showed_at', now);
  },

  // install() tells the browser to show the PWA install prompt to actually have the user install the app
  install() {
    // Show the modal add to home screen dialog
    this.installPromptEvent.prompt();
    // Wait for the user to respond to the prompt
    this.installPromptEvent.userChoice.then((choice) => {
      if (choice.outcome === 'accepted') {
        window.localStorage.setItem('a2hs_has_installed', 1);
      }
      // Clear the saved prompt since it can't be used again
      this.installPromptEvent = null;
    });
  },
};
